import { LinkId } from '../../../../common/AnalyticsContext/LinkId';
import { applyTrackingId } from '../../../../common/AnalyticsContext/applyTrackingId';
import { LoadingSpinner } from '../../../../common/components/LoadingSpinner/LoadingSpinner';
import { EndOfResults } from '../EndOfResults/EndOfResults';
import { Bar, LoadMore, Progress, ResultCountView, Text } from './ResultCount.styles';

interface Props {
  onClickMore: VoidFunction;
  shown: number;
  total: number;
  fetchingMore?: boolean;
  isExtendedSearch?: boolean;
}

export const ResultCount = ({
  shown,
  total,
  onClickMore,
  fetchingMore,
  isExtendedSearch,
}: Props) => {
  const percentage = (shown / total) * 100;

  return (
    <>
      {shown < total && (
        <ResultCountView>
          <Text>
            You've viewed {shown.toLocaleString()} out of {total.toLocaleString()} healthcare
            providers
          </Text>
          <Bar>
            <Progress style={{ width: `${percentage}%` }} />
          </Bar>
          {fetchingMore && <LoadingSpinner />}
          {!fetchingMore && (
            <LoadMore onClick={onClickMore} {...applyTrackingId(LinkId.LOAD_MORE_RESULTS_BUTTON)}>
              Load More
            </LoadMore>
          )}
        </ResultCountView>
      )}
      {shown >= total && !isExtendedSearch && <EndOfResults />}
    </>
  );
};
